module.exports = __webpack_public_path__ + "img/ausencias_icon.930ce172.svg";